AuthRoute = require 'mixins/authenticated-route'

App.OrdersListRoute = Em.Route.extend AuthRoute,
  realTimeService: Em.inject.service('realTime')

  renderTemplate: (controller, model) ->
    @render 'orders.list.sidebar',
      outlet: 'sidebar',
      controller: controller

    @render 'orders.list.content',
      controller: controller

  onNewOrderCreated: (order) ->
    controller = @get('controller')
    return if controller.get('filterIsNotEmpty')

    orders = controller.get('orders')

    if orders.indexOf(order) is -1
      orders.unshiftObject(order)

  setupController: (controller) ->
    controller.get('orders').clear()
    controller.toggleProperty('manualRefresh')

  actions:
    didTransition: ->
      @get('realTimeService').on 'orderCreated', @, @onNewOrderCreated
      false

    willTransition: ->
      @get('realTimeService').off 'orderCreated', @, @onNewOrderCreated
      false
